import { ProductInventoryRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class ProductInventoryService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ProductInventoryRouteService());
	}

	createBatch(productInventoryBatch, sourceOfChange) {
		var url = this.routeService.createBatch(sourceOfChange);
		return this.apiClient.post(url, productInventoryBatch);
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	sync(filter) {
		var url = this.routeService.sync(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	syncWithWms(params, sourceOfChange) {
		var url = this.routeService.syncWithWms(sourceOfChange);
		return this.apiClient.post(url, params);
	}

	syncInventoryForAllWarehouses(params, sourceOfChange) {
		var url = this.routeService.syncInventoryForAllWarehouses(sourceOfChange);
		return this.apiClient.post(url, params);
	}

	syncInventoryForSeller(params, sourceOfChange) {
		var url = this.routeService.syncInventoryForSeller(sourceOfChange);
		return this.apiClient.post(url, params)
	}

	exportInventoryByDate(params, sourceOfChange) {
		var url = this.routeService.exportInventoryByDate(sourceOfChange);
		return this.apiClient.post(url, params);
	}
}

export default ProductInventoryService;
